<script>
	/*
		TCareCheckBoxGroup.svelte
	*/

	import TCareCheckBox from "./TCareCheckBox.svelte";

	export let source;
	export let prop;
	export let setValue;
	export let options;
	
</script>


<style>
</style>

<div class="tcui-control check-box-group">
	{#each options as option}
		<TCareCheckBox {source} {prop} {setValue} value={option.value} label={option.label} />
	{/each}	
</div>

